module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly.76a06a9ee1e3fdc7050fa18bf3ac5b34.png";